import script from "./mainlayout.vue?vue&type=script&setup=true&lang=js"
export * from "./mainlayout.vue?vue&type=script&setup=true&lang=js"

import "./mainlayout.vue?vue&type=style&index=0&id=6a4000e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a4000e4"]])

export default __exports__